import { MAX_COMPETITORS } from '../sim/match/index.ts';

/** Look-only hull tints. Index is `CompetitorId`. */
export const COMPETITOR_TINTS: readonly number[] = [
  0xffffff,
  0xff7a3d,
  0x4ec4ff,
  0xc9a0ff,
];

export function competitorTint(id: number): number {
  return COMPETITOR_TINTS[id] ?? COMPETITOR_TINTS[id % MAX_COMPETITORS] ?? 0xffffff;
}

/** `#rrggbb` for Play HUD row dots. */
export function competitorTintCss(id: number): string {
  return `#${competitorTint(id).toString(16).padStart(6, '0')}`;
}

export function competitorLabel(id: number): string {
  return `Player ${id + 1}`;
}
